export const extractModelNameFromOnlyFansUrl = (url: string): string | null => {
  try {
    // Удаляем пробелы
    const trimmedUrl = url.trim();

    // Проверяем базовый формат URL
    if (!trimmedUrl.includes('onlyfans.com')) {
      return null;
    }

    // Создаем URL объект для парсинга
    const urlObj = new URL(trimmedUrl);

    // Проверяем, что домен правильный
    if (!urlObj.hostname.includes('onlyfans.com')) {
      return null;
    }

    // Извлекаем путь и убираем ведущий слэш
    const path = urlObj.pathname.replace(/^\/+/, '');

    // Если путь пустой, возвращаем null
    if (!path) {
      return null;
    }

    // Берем первую часть пути как имя модели
    const modelName = path.split('/')[0];

    // Проверяем, что имя модели не пустое и содержит только допустимые символы
    // Разрешены: буквы, цифры, точка, подчёркивание, дефис
    if (modelName && /^[a-zA-Z0-9._-]+$/.test(modelName)) {
      return modelName;
    }

    return null;
  } catch (error) {
    // Если URL некорректный, возвращаем null
    return null;
  }
};

// Примеры использования:
// extractModelNameFromOnlyFansUrl('https://onlyfans.com/fefesfesfesfesfes') -> 'fefesfesfesfesfes'
// extractModelNameFromOnlyFansUrl('https://www.onlyfans.com/model123/messages') -> 'model123'
// extractModelNameFromOnlyFansUrl('https://onlyfans.com/test_model') -> 'test_model'
// extractModelNameFromOnlyFansUrl('https://onlyfans.com/shyy.girl') -> 'shyy.girl'
